// extracted by mini-css-extract-plugin
export var measureBox = "_w-0";